





















import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'SQNoResults',
  props: {
    title: {
      type: String
    },
    subtitle: {
      type: String
    }
  },
  setup() {
    return {};
  }
});
